import React, { useCallback, useEffect,useRef, useState } from 'react';
import './App.css';

// JS Modules
import { getLocByIPApi } from './utils/geoLocation';


// Page Components:
// import Header from './components/header/Header';

import TranslationButton from './components/CustomButtons/TranslationButton';

//Sections:
import Services from './sections/service/Services';
import Contact from './sections/contact/Contact';
// import Contact_2 from './sections/contact/Contact_2';

// MUI Components
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';




// Images:
import prof_img from './assets/images/profilePic.jpg'
import prof_img2 from './assets/images/profilePic500.png'



// Theme
import { useTheme } from '@mui/material/styles';

// translation:
import { useTranslation } from 'react-i18next';

function App() {

  const [locationData, setLocationData] = useState(undefined);

  const { t, i18n }    = useTranslation(),
        theme          = useTheme(),
        s_contact_ref  = useRef(null),
        s_home_ref     = useRef(null),
        s_services_ref = useRef(null);


  // useEffect(() => { i18n.changeLanguage('en'); }, [i18n]);

  // TEST DIR AND LANGUAGE CHANGE:
  //   useEffect(() => {

  //   updateDirection();

  //   // Listen for language changes and update direction
  //   i18n.on('languageChanged', updateDirection);

  //   // Cleanup the event listener on component unmount
  //   return () => {
  //     i18n.off('languageChanged', updateDirection);
  //   };

  // }, [i18n]);

    const _getLocByIPApi =  useCallback( async () => {

    try {

      let oResponse = await getLocByIPApi();

      if( oResponse && oResponse.country_code !== 'IL') {
        i18n.changeLanguage('en');
      }
    } catch(e) {
      alert('could not fetch location');
    }

  },[i18n])

  useEffect( () => {

    try{
    let oLocationData = _getLocByIPApi();

    if(oLocationData){
      setLocationData(oLocationData);
    }
    } catch(e){

    }
    
  },[_getLocByIPApi])


  const updateDirection = () => {
      // Use i18n's utility to get the direction for the current language
      const dir = i18n.dir(i18n.language); 
      document.documentElement.setAttribute('dir', dir);
      document.documentElement.setAttribute('lang', i18n.language); // Also set lang attribute for accessibility
    };

  // not in use
  const handleNavigation = (oItem) => {
    switch(oItem.pos) {
      
      case 0:
        s_home_ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      break;

      // case 'About':
      //   s_services_ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // break;
      case 1:
        s_contact_ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      break;

      default: //

      }
   };


  //  Helper Funcions:

  // get location data
  // const _getLocByIPApi = async () => {
  //   try {

  //     let oResponse = await getLocByIPApi();

  //     if( oResponse && oResponse.country_code !== 'IL') {
  //       i18n.changeLanguage('en');
  //     }
  //   } catch(e) {
  //     alert('could not fetch location');
  //   }
  // }


  return (
    <div className="App" >
      <Container maxWidth="lg"  sx={{height:{lg:'100%', md:'100%', xl:'100%', minHeight:'100vh'}, bgcolor: theme.palette.backgrounds.page}}>
        <Grid container> 

      {/* HEADER */}
            {/* navItems={navItems} */}
            <Grid size={12} height={'5vh'} ref={s_home_ref} justifyItems={i18n.language === 'ar' || i18n.language === 'he' ?  'start' : 'end'}>
                {/* <Header handleNavigation = {handleNavigation}></Header> */}
            <TranslationButton t={t} selLang={i18n.language} updateDirection={updateDirection}/>
            </Grid>

      {/* HOME SECTION */}
        <Grid size={12}  sx={{padding:'1rem'}}>
            <Box 
              sx={{width:'100%', marginBottom:'2rem', marginTop:'1rem' }} 
              display={'flex'} 
              flexDirection={'column'} 
              alignItems={'center'} 
              textAlign={'center'}>
              
              {/* <Avatar alt="Remy Sharp"
                
                      sx={{ width: '9rem', height: '9rem', objectFit:'contain', marginTop:'1rem', marginBottom:'1rem'  }} 
                      src={prof_img} /> */}
                <Box
                  component="img"
                  sx={{
                    height: '7rem',
                    width: '7rem',
                    borderRadius:'50%',
                    opacity:'0.9',
                    borderColor:'black'
                  }}
                  alt="logo"
                  src={prof_img2}/> 
                {/* prof_img */}

            <Typography variant="h6" sx={{fontWeight:'bold'}}>{t('home_intro.title')}</Typography>
            <Typography variant="h8" >{t('home_intro.introduction_text')}</Typography>
            </Box>
        </Grid>

      {/* SERVICE SECTION */}
            <Grid size={12}  sx={{padding:'1rem'}} ref={s_services_ref}>
            
            <Box sx={{width:'100%', marginBottom:'2rem', marginTop:'1rem'}} display={'flex'} justifyContent='center' >
              <Typography variant="h5" sx={{fontWeight:'bold'}}>{t('service_section.section_title')}</Typography>
            </Box>
              <Services/>
            </Grid>

      {/* CONTACT SECTION */}
            <Grid size={12} >
            <Box 
              sx={{width:'100%', marginBottom:'2rem', marginTop:'1rem' }} 
              display={'flex'} 
              flexDirection={'column'} 
              alignItems={'center'}
              ref={s_contact_ref}>
                {/* <Typography variant="h4" sx={{fontWeight:'bold'}} >{t('contact_section.title')}</Typography> */}
                {/* <Contact></Contact> */}
                <Contact></Contact>
            </Box>

            </Grid>

        </Grid>
      </Container>
      
      
    </div>
  );
}

export default App;
